import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["notification"];

  connect() {
    this.element.classList.add("transform", "translate-y-0", "opacity-100");

    this.autoDismissTimeout = setTimeout(() => {
      this.dismiss();
    }, 5000);
  }

  dismiss() {
    if (this.autoDismissTimeout) {
      clearTimeout(this.autoDismissTimeout);
    }

    this.element.classList.remove("translate-y-0", "opacity-100");
    this.element.classList.add("translate-y-2", "opacity-0");

    setTimeout(() => {
      this.element.remove();
    }, 300);
  }

  mouseEnter() {
    if (this.autoDismissTimeout) {
      clearTimeout(this.autoDismissTimeout);
    }
  }

  mouseLeave() {
    this.autoDismissTimeout = setTimeout(() => {
      this.dismiss();
    }, 5000);
  }
}
